module.exports = __webpack_public_path__ + "static/media/classes-3.917845d2.jpg";